const computedCommandsMap = {
  concatenate: 'concatenate',
  math: 'math',
  setIf: 'set_if',
  takeIf: 'take_if',
}
export default computedCommandsMap
